module.exports = __webpack_public_path__ + "static/media/help_start_guide.720c73a0.svg";